import React from 'react';
const colors = require('common/lib/colors/colors.less');
import { Button } from './Button';
import { Icon } from './Icon';

const IconContainer = Icon.extend`
  color: ${colors.N100}
  margin-right: 6px;
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
`;

export const IconButton = ({
  children,
  icon,

  ...buttonProps
}) => (
  <Button {...buttonProps}>
    <IconContainer height={12} width={12}>
      {icon}
    </IconContainer>
    {children}
  </Button>
);



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/IconButton.js